import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(horoscope)/horoscope/tarot/TarotClient.tsx");
